/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IImageData, IImageProps, Image, IRequestContext } from '@msdyn365-commerce/core';
import { IHeaderViewProps } from '@msdyn365-commerce-modules/header/dist/types';
import { CalendarSVG } from '../../../utilities/icons';
import { msdyn365Commerce } from '@msdyn365-commerce/core';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
// import { getCookie, setCookie } from '../../../utilities/szf-utils';
import { IHeaderProps } from '../definition-extensions/header.ext.props.autogenerated';

const headerView: React.FC<IHeaderViewProps & IHeaderProps<{}>> = props => {
    const {
        HeaderTag,
        HeaderContainer,
        HeaderTopBarContainer,
        MobileMenuContainer,
        MobileMenuBodyContainer,
        MobileMenuLinksContainer,
        Divider,
    } = props;
    const [showEventModal, setShowEventtModal] = React.useState(false);
    const [showSecondEventModal, setShowSecondEventModal] = React.useState(false);
    const [showThirdEventModal, setShowThirdEventModal] = React.useState(false);
    React.useEffect(() => {
        showEventPop();
        // showSecondEventPopup();
        const currentScrollY = window.scrollY;

        const headerContainerDiv = document.getElementsByClassName('header_szf');
        const headerTag = document.getElementsByTagName('header');
        if (currentScrollY > 0) {
            headerContainerDiv[0].classList.add('szf-solid-header');
            headerTag[0].classList.add('main-header-tag');
        } else {
            if (currentScrollY < 90) {
                headerContainerDiv[0].classList.remove('szf-solid-header');
                headerTag[0].classList.remove('main-header-tag');
            }
        }
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            // const headerContainerDiv = document.getElementsByClassName('ms-header__container');

            // Sunaina //

            const headerContainerDiv = document.getElementsByClassName('header_szf');
            const headerTag = document.getElementsByTagName('header');
       
            if (currentScrollY > 90) {
                headerContainerDiv[0].classList.add('szf-solid-header');
                headerTag[0].classList.add('main-header-tag');
            } else {
                if (currentScrollY < 90) {
                    headerContainerDiv[0].classList.remove('szf-solid-header');
                    headerTag[0].classList.remove('main-header-tag');
                }
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const showEventPop = () => {
        if (props.context.request.telemetryPageName === 'Homepage') {
 
            if(props.config.eventPopupEnable){
                setTimeout(() => {
                    setShowEventtModal(true);
                }, 3000);
            }else if(props.config.secondEventPopupEnable){
                setTimeout(() => {
                    setShowSecondEventModal(true);
                }, 3000);
            }else if(props.config.thirdEventPopupEnable){
                setTimeout(() => {
                    setShowThirdEventModal(true);
                }, 3000);
            }
        }
    };
    const showSecondEventPopup = () => {
        if (props.context.request.telemetryPageName === 'Homepage') {
            setTimeout(() => {
                setShowSecondEventModal(true);
            }, 1500);
        }
    };
    const showThirdEventPopup = () => {
        if (props.context.request.telemetryPageName === 'Homepage') {
            setTimeout(() => {
                setShowThirdEventModal(true);
            }, 1500);
        }
    };
    const closeEventPopup =() =>{
        if(props.config.secondEventPopupEnable){
            setShowEventtModal(false);
            showSecondEventPopup();
        }
        else{
            setShowEventtModal(false);
            showThirdEventPopup();
        }
    }
    const closeSecondEventPopup =() =>{
        setShowSecondEventModal(false)
        showThirdEventPopup();
    }
    const imageGeneration = (
        props: { context: { request: IRequestContext | undefined }; typeName: any; id: any },
        image:
            | IImageData
            | (JSX.IntrinsicAttributes &
                  JSX.IntrinsicClassAttributes<Image> &
                  Readonly<IImageProps> &
                  Readonly<{ children?: React.ReactNode }>)
            | undefined,
        className: string
    ) => {
        const successImageProps = {
            gridSettings: props.context.request!.gridSettings ?? {},
            imageSettings: image?.imageSettings
        };
        const imageContainer = { className: className };
        const successImage = (
            <Node {...imageContainer}>
                <Image
                    {...image}
                    {...successImageProps}
                    requestContext={props.context.request}
                    preserveImageSpace={true}
                    editProps={{
                        key: image ?? {},
                        requestContext: props.context.request!,
                        moduleType: props.typeName,
                        imagePropertyName: 'image',
                        moduleId: props.id
                    }}
                    shouldSkipToMainImage
                />
            </Node>
        );
        return successImage;
    };
    const EventPopup = () => {
        return (
            <Modal
                isOpen={showEventModal}
                toggle={() => closeEventPopup()}
                backdrop="static"
                keyboard={true}
                unmountOnClose={true}
                size={'md'}
                className="homepage_popup modal-dialog-centered"
            >
                <ModalHeader toggle={() => closeEventPopup()}></ModalHeader>
                <ModalBody>
                    {
                        <div className='szf-modal-body'>
                            <div className='festival-activities-item'>
                                <div className='festival-activities-item__img'>
                                    {props.config.eventPopupImage &&
                                        imageGeneration(props, props.config.eventPopupImage, 'ms-content-block__image')}
                                </div>
                                <div className='msc-product'>
                                    <div className={`festival-activities-item__date`}>
                                        <CalendarSVG />
                                        <p>{props.config.eventPopupDate}</p>
                                    </div>
                                    <h2 className='msc-product__title'>{props.config.eventPopupHeading}</h2>
                                </div>{' '}
                                <p className='msc-product__desc'>{props.config.eventPopupDescription}</p>
                            </div>
                        </div>
                    }
                </ModalBody>
                <ModalFooter>
                    {msdyn365Commerce.isBrowser && window && props.config.eventRedirectionLink && (
                        <Button href={props.config.eventRedirectionLink} target="_blank">{props.resources.bookNowBtnLabel}</Button>
                    )}
                </ModalFooter>
            </Modal>
        );
    };
    const SecondEventPopup = () => {
        return (
            <Modal
                isOpen={showSecondEventModal}
                toggle={() => closeSecondEventPopup()}
                backdrop="static"
                keyboard={true}
                unmountOnClose={true}
                size={'md'}
                className="homepage_popup modal-dialog-centered"
            >
                <ModalHeader toggle={() => closeSecondEventPopup()}></ModalHeader>
                <ModalBody>
                    {
                        <div className='szf-modal-body'>
                            <div className='festival-activities-item'>
                                <div className='festival-activities-item__img'>
                                    {props.config.secondEventPopupImage &&
                                        imageGeneration(props, props.config.secondEventPopupImage, 'ms-content-block__image')}
                                </div>
                                <div className='msc-product'>
                                    <div className={`festival-activities-item__date`}>
                                        <CalendarSVG />
                                        <p>{props.config.secondEventPopupDate}</p>
                                    </div>
                                    <h2 className='msc-product__title'>{props.config.secondEventPopupHeading}</h2>
                                </div>
                                <p className='msc-product__desc'>{props.config.secondEventPopupDescription}</p>
                            </div>
                        </div>
                    }
                </ModalBody>
                <ModalFooter>
                    {msdyn365Commerce.isBrowser && window && props.config.secondEventRedirectionLink && (
                        <Button href={props.config.secondEventRedirectionLink} target="_blank">{props.resources.bookNowBtnLabel}</Button>
                    )}
                </ModalFooter>
            </Modal>
        );
    };
    const ThirdEventPopup = () => {
        return (
            <Modal
                isOpen={showThirdEventModal}
                toggle={() => setShowThirdEventModal(!showThirdEventModal)}
                backdrop='static'
                keyboard={true}
                unmountOnClose={true}
                size={'md'}
                className='homepage_popup modal-dialog-centered'
            >
                <ModalHeader toggle={() => setShowThirdEventModal(!showThirdEventModal)}></ModalHeader>
                <ModalBody>
                    {
                        <div className='szf-modal-body'>
                            <div className='festival-activities-item'>
                                <div className='festival-activities-item__img'>
                                    {props.config.thirdEventPopupImage &&
                                        imageGeneration(props, props.config.thirdEventPopupImage, 'ms-content-block__image')}
                                </div>
                                <div className='msc-product'>
                                    <div className={`festival-activities-item__date`}>
                                        <CalendarSVG />
                                        <p>{props.config.thirdEventPopupDate}</p>
                                    </div>
                                    <h2 className='msc-product__title'>{props.config.thirdEventPopupHeading}</h2>
                                </div>
                                <p className='msc-product__desc'>{props.config.thirdEventPopupDescription}</p>
                            </div>
                        </div>
                    }
                </ModalBody>
                <ModalFooter>
                    {msdyn365Commerce.isBrowser && window && props.config.thirdEventRedirectionLink && (
                        <Button href={props.config.thirdEventRedirectionLink} target='_blank'>
                            {props.resources.bookNowBtnLabel}
                        </Button>
                    )}
                </ModalFooter>
            </Modal>
        );
    };

    return (
        <>
            {/* {!loading &&  */}
            <Module {...HeaderTag}>
                <Node {...HeaderContainer}>
                    <Node {...HeaderTopBarContainer}>
                        {props.navIcon}
                        {props.logo}
                        {_renderReactFragment(props.search)}
                        {props.preferredStore}
                        {_renderDesktopAccountBlock(props)}
                        {props.wishListIconDesktop}
                        <Node {...Divider} />
                        {props.cartIcon}
                        {_renderReactFragment(props.siteOptions)}
                    </Node>
                    <Node {...MobileMenuContainer}>
                        <Node {...MobileMenuBodyContainer}>
                            {props.MobileMenuHeader}
                            {_renderReactFragment(props.menuBar)}
                            <Node {...MobileMenuLinksContainer}>
                                {props.accountLinks ? props.accountLinks.map(link => link) : false}
                                {props.siteOptions}
                                {props.wishListIconMobile}
                                {props.signInLink}
                                {props.signOutLink}
                            </Node>
                        </Node>
                    </Node>
                    {_renderReactFragment(props.menuBar)}
                    {showThirdEventModal && props.config.thirdEventPopupEnable && <ThirdEventPopup />}
                    {showSecondEventModal && props.config.secondEventPopupEnable && <SecondEventPopup />}
                    {showEventModal && props.config.eventPopupEnable && <EventPopup />}
                </Node>
            </Module>
            {/* } */}
        </>
    );
};

function _renderDesktopAccountBlock(props: IHeaderViewProps): JSX.Element | null {
    const {
        AccountInfoDropdownParentContainer,
        AccountInfoDropdownPopoverConentContainer,
        accountInfoDropdownButton,
        signOutLink,
        signInLink,
        accountLinks
    } = props;

    if (AccountInfoDropdownParentContainer) {
        if (AccountInfoDropdownPopoverConentContainer) {
            return (
                <Node {...AccountInfoDropdownParentContainer}>
                    {accountInfoDropdownButton}
                    <Node {...AccountInfoDropdownPopoverConentContainer}>
                        {accountLinks ? accountLinks.map(link => link) : false}
                        {signOutLink}
                    </Node>
                </Node>
            );
        } else if (signInLink) {
            return <Node {...AccountInfoDropdownParentContainer}>{signInLink}</Node>;
        }
    }
    props.context.telemetry.error('Header content is empty, module wont render.');
    return null;
}

function _renderReactFragment(items: React.ReactNode[]): JSX.Element | null {
    return (
        <>
            {items && items.length > 0
                ? items.map((slot: React.ReactNode, index: number) => {
                      return <React.Fragment key={index}>{slot}</React.Fragment>;
                  })
                : null}
        </>
    );
}

export default headerView;
